<template>
  <div class="slider">
    <Carousel :="config" v-if="images.length">
      <Slide v-for="(image, index) in images" :key="index">
        <component :is="image.custom_fields.url ? 'a' : 'span'" :href="image.custom_fields.url || ''">
          <img :src="image.custom_fields.image" class="slider-image">
        </component>
      </Slide>

      <template #addons>
        <Pagination />
      </template>
    </Carousel>
  </div>
</template>

<script>
import { Carousel, Slide, Pagination } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';

export default {
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  data() {
    return {
      images: [],
      config: {
        autoplay: 4000,
        itemsToShow: 1,
        wrapAround: true,
        mouseDrag: true,
      },
    };
  },
  created() {
    this.getKVImages();
  },
  methods: {
    async getKVImages() {
      try {
        const images = await this.axios({
          method: 'GET',
          url: '/gekv/',
        });
        console.log(images);
        if (images.data.length) {
          this.images = images.data;
        }
      } catch (e) {
        console.log(e.response?.data || e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.slider {
  width: 100%;
  margin: 0 auto;
  padding-top: 80px;
}

.carousel__slide {
  width: 100%;
  height: auto;
  > * {
    display: block;
    width: 100%;
    height: auto;
  }
}

.slider-image {
  display: block;
  width: 100%;
  height: auto;
}

@media screen and (min-width: 576px) {
  .slider-image {
    object-fit: cover;
    width: 100%;
    height: auto;
    max-height: 300px;
  }
}

@media screen and (min-width: 768px) {
  .slider-image {
    max-height: 400px;
  }
}

@media screen and (min-width: 1024px) {
  .slider-image {
    max-height: 500px;
  }
}

</style>


<style lang="scss">
.carousel__pagination {
  bottom: 2em;
  &-button {
    background-color: #999;
    width: 40px;
    &--active {
      background-color: #333;
    }
  }
}
</style>
